import React from 'react';
import Hero from '../Hero';
import Services from '../Services';
import Mission from '../Mission'
import ProactiveMessage from '../ProactiveMessage';
import ScrollToTop from '../ScrollToTop';

const Home = () => {
  return (
    <div>
      <Hero />
      <Mission />
      <Services />
      <ProactiveMessage />
      <ScrollToTop />
    </div>
  );
};

export default Home;